import React, { useState } from 'react';

import { useVersion } from '../contexts/VersionContext';
import './VersionBadge.css';

export const VersionBadge: React.FC = () => {
  const { versionInfo, loading } = useVersion();
  const [expanded, setExpanded] = useState(false);

  if (loading || !versionInfo) return null;

  const { app, build, git } = versionInfo;
  const buildDate = new Date(build.timestamp);
  const formattedDate = buildDate.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });

  const handleCopyCommit = () => {
    navigator.clipboard.writeText(git.commit);
  };

  return (
    <div className='version-badge'>
      <button
        className='version-badge-toggle'
        onClick={() => setExpanded(!expanded)}
        title='Click to view version details'
        aria-expanded={expanded}
      >
        <span className='version-text'>Build {build.number}</span>
        <span className={`version-icon ${expanded ? 'expanded' : ''}`}>▼</span>
      </button>

      {expanded && (
        <div className='version-details'>
          <div className='version-detail-item'>
            <span className='label'>Version:</span>
            <span className='value'>{app.version}</span>
          </div>

          <div className='version-detail-item'>
            <span className='label'>Build:</span>
            <span className='value'>{build.number}</span>
          </div>

          <div className='version-detail-item'>
            <span className='label'>Commit:</span>
            <span className='value monospace' title={git.commit}>
              {git.commit}
              <button
                className='copy-btn'
                onClick={handleCopyCommit}
                title='Copy commit hash'
              >
                📋
              </button>
            </span>
          </div>

          <div className='version-detail-item'>
            <span className='label'>Branch:</span>
            <span className='value'>{git.branch}</span>
          </div>

          <div className='version-detail-item'>
            <span className='label'>Date:</span>
            <span className='value'>{formattedDate}</span>
          </div>

          <div className='version-detail-item'>
            <span className='label'>Environment:</span>
            <span className={`value env-${build.environment}`}>
              {build.environment.toUpperCase()}
            </span>
          </div>
        </div>
      )}
    </div>
  );
};
